<template>
  <div
    class="ws-text-button"
    :class="{primary:primary,narrow:narrow,white:white,small:small,noPadding:noPadding,red:red,fontSizeXs:fontSizeXs,fontSizeMd:fontSizeMd,fontSizeLg:fontSizeLg,bold:bold}"
    @click.stop="onclick()"
  >
    <router-link
      v-if="to"
      :to="to"
      class="ll-text-button_content"
    >
      <i
        v-if="leadingIcon"
        :class="leadingIcon"
        class="ll-text-button_icon"
      />
      <img
        v-if="leadingImage"
        :src="leadingImage"
        alt=""
        class="ll-text-button_image"
      >
      <p class="ll-text-button_text">
        <slot /> <span v-if="num">({{ num }})</span>
      </p>
      <i
        v-if="trailingIcon"
        :class="trailingIcon"
        class="ll-text-button_icon after"
      />
    </router-link>
    <div
      v-else
      class="ll-text-button_content"
    >
      <i
        v-if="leadingIcon"
        :class="[leadingIcon,{'icon-sm':isIconSm}]"
        class="ll-text-button_icon"
      />
      <img
        v-if="leadingImage"
        :src="leadingImage"
        alt=""
        class="ll-text-button_image"
      >
      <p class="ll-text-button_text">
        <slot /> <span v-if="num">({{ num }})</span>
      </p>
      <i
        v-if="trailingIcon"
        :class="trailingIcon"
        class="ll-text-button_icon after"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: "TextButton",
  props: {
    to: {
      type: String,
      default: "",
    },
    textLabel: {
      type: String,
      default: "",
    },
    primary: {
      type: Boolean,
      default: false,
    },
    narrow: {
      type: Boolean,
      default: false,
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    white: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    noPadding: {
      type: Boolean,
      default: false,
    },
    trailingIcon: {
      type: String,
      default: "",
    },
    num: {
      type: Number,
      default: 0,
    },
    red: {
      type: Boolean,
      default: false,
    },
    leadingImage: {
      type: String,
      default: "",
    },
    fontSizeXs: {
      type: Boolean,
      default: false,
    },
    fontSizeMd: {
      type: Boolean,
      default: false,
    },
    fontSizeLg: {
      type: Boolean,
      default: false,
    },
    isIconSm: {
      type: Boolean,
      default: false,
    },
    bold: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onclick() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/text-button";
</style>